import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectCustomerDetailSelector } from 'redux/selectors';

export const useNewAccount = () => {
  const [showUnderReviewMessage, setShowUnderReviewMessage] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');
  const customerDetails = useSelector(selectCustomerDetailSelector);

  const handleReviewMessage = (message, status) => {
    setResponseMessage(message);
    setShowUnderReviewMessage(status);
  };

  return {
    showUnderReviewMessage,
    handleReviewMessage,
    customerDetails,
    responseMessage,
  };
};
